export const register = {
  title: "Free Sign Up",
  email_label: "Email",
  password_label: "Password",
  pack_label: "Pack ID",
  company_name_label: "Company Name",
  owner_name_label: "Owner Name",
  phone_label: "Phone Number",
  rib_label: "RIB",
  kbis_label: "Upload KBIS File",

  email_required: "Email is required",
  email_invalid: "Invalid email",
  password_required: "Password is required",
  pack_required: "Pack is required",
  company_name_required: "Company name is required",
  owner_name_required: "Owner name is required",
  phone_required: "Phone number is required",
  rib_required: "RIB is required",
  kbis_required: "KBIS file is required",

  already_account: "Already have an account?",
  login: "Log in",
  next: "Next",
  loading: "Loading...",

  address_label: "Address",
  address_required: "Address is required",

  urssaf_label: "urssaf",
  fiscale_label: "Certificate of Tax Regularization",
  rcPro_label: "rcpro",
  addFile: "Add file",
  fichier_label: "select file",
  title_file: "File title",
  alert_pack: "You must select the package",
};
